import React, { useEffect, useState } from "react";
import { CloseRounded, Logout, Menu, Search } from '@mui/icons-material';
import { Button, FormControl, IconButton, InputAdornment, Popover, SliderThumb, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAvatarName, hideLoadingOverlay, showLoadingOverlay } from "../../../utils";
import { useMessage } from "../../../base/MessageProvider";
import { logout } from "../../actions/auth";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "../../../base/useMediaQuery";
import clsx from "clsx";

const Header = ({ setNavBar, open }) => {
    const username = useSelector(state => state.authReducer?.username);
    const mobileNo = useSelector(state => state.authReducer?.mobileNo);
    const [anchorEl, setAnchorEl] = useState(null);
    const alert = useMessage();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isDeskTop = useMediaQuery('(min-width: 850px)');

    useEffect(() => {
        document.title = 'STARNEX - Admin Panel'
    }, [])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        showLoadingOverlay("Logging out")
        await dispatch(logout(() => {
            navigate('/admin/login', { replace: true });
        }, (err) => {
            alert.showError(err?.message ?? "Something went wrong");
        }))
        hideLoadingOverlay();
    }

    const onClickLogout = async () => {
        alert.showConfirmation({
            message: 'Are you sure you want to logout?',
            button1Title: 'Cancel',
            button2Title: 'Logout',
            onPressBtn1: () => {},
            onPressBtn2: handleLogout,
        })
    }
    
    const showDropdown = Boolean(anchorEl);

    const toggleDrawer = () => setNavBar(!open);

    return (
        <div className={clsx("fixed top-0 left-0 z-20 bg-white w-full h-[89px] shadow-[0_4px_3px_#E8E8E9] flex items-center justify-between", {
            "h-[89px] px-5": isDeskTop,
            "h-[65px] px-3": !isDeskTop
        })}>
            <div className="flex items-center gap-2">
                {!isDeskTop && (
                    <IconButton onClick={toggleDrawer} className={clsx("duration-300 transition-transform", { "rotate-90": open })}>
                        {open ? <CloseRounded className="text-gray-500" /> : <Menu className="text-gray-500" />}
                    </IconButton>
                )}
                {/* <div className={clsx("font-['CG-Medium'] text-[#5c5f62] whitespace-nowrap", {
                    "text-[32px] tracking-[0.15em] leading-[30px]": isDeskTop,
                    "text-[24px] tracking-[0.15em] leading-[23px]": !isDeskTop
                })}>
                    STARNEX
                </div> */}
                <img 
                    src={require("../../../assets/images/white-bg-logo.png")}
                    className={isDeskTop ? "h-[40px]" : "h-[28px]"}
                />
            </div>
            <div className="hidden">
                <FormControl className="bg-[#f1f2f3] w-[600px] rounded-[4px] border-2 border-solid border-[#e1e3e5]">
                    <TextField 
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search />
                                </InputAdornment>
                            ),
                        }} 
                        size="small" 
                        placeholder="Search" 
                        className="text-[#5c5f62] text-[14px] rounded-[4px]" 
                    />
                </FormControl>
            </div>
            <div className={clsx("flex items-center gap-2", { "mr-9": isDeskTop } )}>
                <div onClick={handleClick} className="cursor-pointer w-[35px] h-[35px] bg-zinc-200 rounded-full flex items-center justify-center text-[#8D9196] text-base leading-[30px]">{getAvatarName(username ?? "")}</div>
                {isDeskTop && <div className="text-neutral-800 text-base font-['Poppins-Regular'] leading-[30px]">{username}</div>}
            </div>
            <Popover
                open={showDropdown}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div id="drop-down" className="min-w-[200px] bg-white p-2 shadow-[0_0_10px_grey] rounded-lg">
                    <ul className="flex flex-col items-center ">
                        <li className="py-[2px] px-2 rounded-lg text-sm font-['Poppins-Medium']">{username}</li>
                        <li className="py-[2px] px-2 rounded-lg text-sm font-['Poppins-Medium']">{mobileNo} </li>
                        <li className='pt-1 w-full'>
                            <Button onClick={onClickLogout} className="py-2 px-2 w-full font-bold cursor-pointer bg-gray-100 hover:bg-gray-200 rounded-lg" > 
                                Logout 
                            </Button>
                        </li>
                    </ul>
                </div>
            </Popover>
        </div>
    );
};

export default React.memo(Header, (prevProps, nextProps) => prevProps.open === nextProps.open);
